import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FilterWrapper } from './styles';
import IconFont from '../../../../components/shared/IconFont';

class FilterIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // isSelected: false,
    };
  }

  handleFilter = () => {
    if (this.props.isAvailable) {
      this.setState({
        //isSelected: !this.state.isSelected,
      });
      this.props.changeSportFilter(!this.props.isSelected, this.props.sportId);
      if (process.env.REACT_APP_SITE !== 'corriere' && window.omniture) {
        window.omniture.trkEventMc(`Matchcenter filtro ${this.props.sportName}`);
      }
    }
  };


  render() {
    const {
      iconClass,
      isAvailable,
      isSelected,
    } = this.props;
    //const { isSelected } = this.state;
    return (
      <FilterWrapper onClick={this.handleFilter}>
        {iconClass &&
          (
            <IconFont
              font={this.props.isMobile ? '31' : '26'}
              marginRight={this.props.isMobile ? '0.6' : '0.65'}
              className={iconClass}
              isSelected={isSelected}
              isAvailable={isAvailable}
              withCursor={isAvailable}
              isFilterBar
            />
          )
        }
      </FilterWrapper>
    );
  }
}

FilterIcon.propTypes = {
  iconClass: PropTypes.string,
  isAvailable: PropTypes.bool,
  isSelected: PropTypes.bool,
  sportId: PropTypes.any,
  changeSportFilter: PropTypes.any,
  isMobile: PropTypes.bool,
  sportName: PropTypes.any,
};

export default FilterIcon;
